import {
  DEFAULT_LISTING_SURFACES,
  mergeListingSurfaces,
  type ListingSurfaceConfig,
  type ListingSurfaceKey,
} from '@shopgnd/shared';

let cachedSurfaces: ListingSurfaceConfig[] = DEFAULT_LISTING_SURFACES;

export function applyListingSurfaces(surfaces: ListingSurfaceConfig[]): void {
  cachedSurfaces = surfaces;
}

export function getRuntimeListingSurfaces(): ListingSurfaceConfig[] {
  return cachedSurfaces;
}

export function getRuntimeSurface(key: ListingSurfaceKey): ListingSurfaceConfig {
  return cachedSurfaces.find((s) => s.surfaceKey === key) ?? DEFAULT_LISTING_SURFACES.find((s) => s.surfaceKey === key)!;
}

export function parseListingSurfacesJson(raw: string | undefined | null): ListingSurfaceConfig[] {
  if (!raw?.trim()) return DEFAULT_LISTING_SURFACES;
  try {
    const parsed = JSON.parse(raw) as ListingSurfaceConfig[];
    if (!Array.isArray(parsed)) return DEFAULT_LISTING_SURFACES;
    return mergeListingSurfaces(parsed);
  } catch {
    return DEFAULT_LISTING_SURFACES;
  }
}

export function serializeListingSurfaces(surfaces: ListingSurfaceConfig[]): string {
  return JSON.stringify(surfaces, null, 2);
}
